import Vue from 'vue'
import Router from 'vue-router'

// 导入页面组件
import Login from '../views/Login.vue' // 登录页
import Home from '../views/Home.vue'   // 主页
import TaskList from '../views/TaskList.vue' // 任务列表
import TaskCreate from '../views/TaskCreate.vue' // 任务创建
import Callback from '../views/Callback.vue'
import ReportData from '../views/ReportData.vue'
// 原有导入导出组件
import ExcelImport from '../views/excel/Import'
import ExcelExport from '../views/excel/Export'
// 新增5个导入导出组件
import StoreBusinessImport from '../views/excel/StoreBusinessImport'
import StoreAuxiliaryImport from '../views/excel/StoreAuxiliaryImport'
import SerialCodeImport from '../views/excel/SerialCodeImport'
import StoreAllDataExport from '../views/excel/StoreAllDataExport'
import AbnormalDataExport from '../views/excel/AbnormalDataExport'

Vue.use(Router)
const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    // 1. 登录页（独立路由，无需登录）
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { requiresAuth: false }
    },
    // 2. 回调页（独立路由，无需登录）
    {
      path: '/callback',
      name: 'Callback',
      component: Callback,
      meta: { requiresAuth: false }
    },
    // 3. 主页（父路由，需要登录）
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { requiresAuth: true },
      // 关键修复：移除强制redirect，改为默认子路由
      children: [
        // 默认子路由：访问 / 时显示任务列表
        {
          path: '', // 空路径 = 默认子路由
          name: 'DefaultHome',
          component: TaskList,
          meta: { title: '任务列表', requiresAuth: true }
        },
        {
          path: 'tasks',
          name: 'TaskList',
          component: TaskList,
          meta: { title: '任务列表', requiresAuth: true }
        },
        {
          path: 'task/create',
          name: 'TaskCreate',
          component: TaskCreate,
          meta: { title: '创建任务', requiresAuth: true }
        },
        {
          path: 'report/reportData',
          name: 'ReportData',
          component: ReportData,
          meta: { title: '报表查看', requiresAuth: true }
        },
        // Excel相关子路由（全部去掉前置 /）
        {
          path: 'excel/import',
          name: 'ExcelImport',
          component: ExcelImport,
          meta: { title: '基础表数据导入', requiresAuth: true }
        },
        {
          path: 'excel/export',
          name: 'ExcelExport',
          component: ExcelExport,
          meta: { title: '业务汇总表导出', requiresAuth: true }
        },
        {
          path: 'excel/import/store-business',
          name: 'StoreBusinessImport',
          component: StoreBusinessImport,
          meta: { title: '店面业务数据导入(6Sheet)', requiresAuth: true }
        },
        {
          path: 'excel/import/store-auxiliary',
          name: 'StoreAuxiliaryImport',
          component: StoreAuxiliaryImport,
          meta: { title: '店面辅助数据导入(6Sheet)', requiresAuth: true }
        },
        {
          path: 'excel/import/serial-code',
          name: 'SerialCodeImport',
          component: SerialCodeImport,
          meta: { title: '串码数据导入(1Sheet)', requiresAuth: true }
        },
        {
          path: 'excel/export/store-all',
          name: 'StoreAllDataExport',
          component: StoreAllDataExport,
          meta: { title: '店面全量数据导出(12Sheet)', requiresAuth: true }
        },
        {
          path: 'excel/export/check-exception',
          name: 'AbnormalDataExport',
          component: AbnormalDataExport,
          meta: { title: '核对异常数据导出(5Sheet)', requiresAuth: true }
        }
      ]
    },
    // 4. 404页面（最后匹配）
    {
      path: '*',
      redirect: (to) => {
        const token = localStorage.getItem('accessToken')
        const adminName = localStorage.getItem('adminName')
        // 已登录：跳主页；未登录：跳登录页并携带原路径
        return (token && adminName) 
          ? '/' 
          : { path: '/login', query: { redirect: to.fullPath } }
      }
    }
  ]
})

// 路由守卫（最终修复版）
router.beforeEach((to, from, next) => {
  // 标记：是否是登录后跳转（避免循环）
  const isLoginRedirect = from.path === '/login' && to.query.redirect === undefined
  
  // 1. 解析URL中的token参数（登录回调）
  const urlToken = to.query.token;
  if (urlToken) {
    try {
      const payload = JSON.parse(atob(urlToken.split('.')[1]));
      const userId = payload.sub;
      localStorage.setItem('accessToken', urlToken);
      localStorage.setItem('adminName', userId);
      
      // 登录回调：跳转到redirect或主页（避免重复校验）
      const redirect = to.query.redirect || '/'
      next({ path: redirect, query: {}, replace: true });
      return;
    } catch (e) {
      console.error('解析Token失败：', e);
      localStorage.removeItem('accessToken');
      localStorage.removeItem('adminName');
      next('/login');
      return;
    }
  }

  // 2. 登录态校验
  const token = localStorage.getItem('accessToken');
  const adminName = localStorage.getItem('adminName');
  const isLogin = !!token && !!adminName;
  const requiresAuth = Boolean(to.meta.requiresAuth);

  // 核心规则（彻底避免循环）
  if (requiresAuth) {
    if (!isLogin) {
      // 未登录访问受保护页面：跳登录页（携带redirect）
      next({ 
        path: '/login', 
        query: { redirect: to.fullPath },
        replace: true // 替换历史记录，避免回退循环
      });
    } else if (isLoginRedirect && to.path === '/') {
      // 登录后跳主页：直接放行（不触发二次重定向）
      next();
    } else {
      // 已登录访问受保护页面：正常放行
      next();
    }
  } else {
    if (to.path === '/login' && isLogin) {
      // 已登录访问登录页：跳主页（replace避免历史记录）
      next({ path: '/', replace: true });
    } else {
      // 无需登录的页面：直接放行
      next();
    }
  }
});

export default router